import React from 'react';
import styles from './styles.module.css';
import { Button, Grid, DialogActions, } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import SaleInvoice from 'components/utils/InvoiceDownload/SaleInvoice';

function SalesUpdateSuccessDialog(props) {
  const { handleClose, data } = props;
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapperSm}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tPopup('Invoice {{action}} successfully', { action: data.action === 'create' ? tCommon('created') : tCommon('updated') })}</h2>
        </div>
        <div className={styles.inputSec}>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ p: '16px 10px' }}>
              <span className={styles.msg}>
                <Trans i18nKey="popup:invoice_success_message" values={{ invoiceNo: data.invoiceNo, action: data.action === 'create' ? tCommon('created') : tCommon('updated') }} components={{ strong: <strong /> }} />
              </span>
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            {data.sale && (
              <SaleInvoice
                bill={data.sale}
                showOptions={false}
                renderAs="button"
              />
            )}
            <Button variant="contained" color="primary" className={styles.btnView} onClick={handleClose}>
              {tCommon('Close')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default SalesUpdateSuccessDialog;
